<template>
  <profile-main>
    <profile-header activeMenu="defaultPrice" slot="profileNavigation" />
    <loading-container :loading="loadingConfig">
      <div class="mb-4">
        <div class="form-group">
          <div class="col-md-12">
            <input-select
              name="status"
              placeholder="Select a catalog to configuration"
              class="m-0"
              :options="catalogOptions"
              @input="value => selectCatalog(value)"
            />
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-12" v-if="form.catalog">
          <form class="form-horizontal" @submit.prevent="() => {}">
            <div v-for="item in sizes" class="" :key="item.value">
              <input-text
                :inputGroup="true"
                :placeholder="item.text"
                :value="form.prices && form.prices[item.value]"
                type="number"
                :errors="error[`prices.${item.value}`]"
                @input="value => setField({ key: `prices.${item.value}`, value, type: `${item.value}`})"
              >
                <div class="input-group-prepend" slot="prefix">
                  <span class="input-group-text">{{item.text}}</span>
                </div>
              </input-text>
            </div>

            <form-button
              type="primary"
              input-type="button"
              :disabled="loading"
              :loading="loading"
              text="Update"
              :click="() => updateConfiguration()"
            />
          </form>
        </div>
        <div class="col-md-12" v-else>
          Please select a catalog!
        </div>
      </div>
    </loading-container>
  </profile-main>
</template>


<script>
  import { mapGetters, mapActions } from "vuex";

  import LoadingContainer from "@/components/Misc/LoadingContainer";
  import InputSelect from "@/components/Form/InputSelect";
  import InputText from "@/components/Form/InputText";
  import LinkButton from "@/components/Misc/LinkButton";
  import FormButton from "@/components/Form/FormButton";

  import ProfileHeader from './components/Header';
  import ProfileMain from './components/Main';

  export default {
    name: "Price",
    components: {
      LoadingContainer,
      InputSelect,
      LinkButton,
      InputText,
      FormButton,
      ProfileHeader,
      ProfileMain,
    },
    beforeMount() {
      this.getConfiguration();
    },
    computed: {
      ...mapGetters({
        form: "configuration/form",
        loading: 'configuration/loading',
        loadingConfig: 'configuration/loadingConfig',
        sizes: 'configuration/sizes',
        error: 'configuration/error',
        catalogOptions: "upload/mockupOptions",
      }),
      routeName() {
        return this.$router.name;
      },
      currentPage() {
        return this.$store.state.route.meta.title;
      },
    },
    methods: {
      ...mapActions({
        setField: "configuration/setField",
        setSizesConfig: "configuration/setSizesConfig",
        getConfiguration: "configuration/getConfiguration",
        updateConfiguration: "configuration/updateConfiguration",
      }),
      selectCatalog(catalog) {
        const thisCatalog = this.catalogOptions.find(item => item.value === parseInt(catalog));
        this.setSizesConfig(thisCatalog);
      },
    }
  };
</script>
